import styled from 'styled-components';

import { colours } from 'themes/default';

export const RemainingContainer = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  font-style: italic;
  flex: 1;

  > span:first-of-type {
    flex: 0.8;
  }

  > div {
    margin: 0;
  }

  .tooltip {
    font-style: normal;
    pointer-events: auto !important;

    &:hover {
      visibility: visible !important;
      opacity: 1 !important;
    }

    ul {
      margin: 0 14px;
      padding: 0;

      li {
        color: ${colours.Shades.TintBlue40};
        cursor: pointer;
        pointer-events: auto !important;
      }
    }
  }
`;

export const RemainingLabel = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 26px;
  box-sizing: border-box;
  font-weight: 700;
  font-style: normal;
  cursor: pointer;
  color: ${colours.Shades.TintBlue40};
  border-radius: 3px;
  border: 1px solid ${colours.Shades.TintBlue40};
`;

export const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  a {
    color: ${colours.Shades.TintBlue40};
  }
`;
